import { useSearchParams } from 'react-router-dom';

import type { FilterFieldValue } from '@shared/api/findings';
import { filterFormSchema } from '@shared/api/findings/filter-form.schema';

export function useFiltersFromSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  let filters: Record<string, FilterFieldValue> = {};
  try {
    const filtersRaw = searchParams.get('filters');
    if (filtersRaw) {
      filters = filterFormSchema.shape.fieldValues.parse(JSON.parse(filtersRaw));
    }
  } catch {
    // If parsing fails, we can ignore it and use the default empty filters
  }

  function setFilters(newFilters: Record<string, FilterFieldValue>) {
    const newParams = new URLSearchParams(searchParams);
    if (Object.keys(newFilters).length > 0) {
      newParams.set('filters', JSON.stringify(newFilters));
    } else {
      newParams.delete('filters');
    }
    setSearchParams(newParams, { replace: true });
  }

  return { filters, setFilters };
}
